export const meta_infos = [
  {
    url: "https://www.aliff.in/country-about/australia",
    country:'australia',
    title: "Study Abroad Consultants Australia - Study Consultants - Aliff",
    description:
      "Looking for study abroad consultants in Australia? Get expert advice from leading study consultants to make your overseas education dreams come true. Enquire now for more info!",
    metaTitle: "Study Abroad Consultants Australia",
    alt: "Study Consultants",
  },
  {
    url: "https://www.aliff.in/country-about/barbados",
    country:'barbados',
    title: "Study Consultants Barbados - Study Abroad Counselling - Aliff",
    description:
      "Looking for study consultants in Barbados? Get personalized study abroad counselling to guide your academic future abroad. Enquire now for the best guidance!",
    metaTitle: "Study Consultants Barbados",
    alt: "Study Abroad Counselling",
  },
  {
    url: "https://www.aliff.in/country-about/canada",
    country:'canada',
    title: "Study Abroad Consultants Canada - Best Consultants - Aliff",
    description:
      "Looking for study abroad consultants in Canada? Trust the best consultants to guide your study abroad journey for a successful academic future. Enquire now!",
    metaTitle: "Study Abroad Consultants Canada",
    alt: "Best Consultants",
  },
  {
    url: "https://www.aliff.in/country-about/france",
    country:'france',
    title:
      "Study Abroad Consultants France - Foreign Study Consultancy - Aliff",
    description:
      "Looking for study abroad consultants in France? Our foreign study consultancy will help you secure admission to top universities abroad. Enquire now for expert guidance!",
    metaTitle: "Study Abroad Consultants France",
    alt: "Foreign Study Consultancy",
  },
  {
    url: "https://www.aliff.in/country-about/georgia",
    country:'georgia',
    title:
      "Study Abroad Consultants Georgia - Abroad Study Consultancy - Aliff",
    description:
      "Looking for study abroad consultants in Georgia? Get expert help from an abroad study consultancy to guide you in your international education journey. Enquire now!",
    metaTitle: "Study Abroad Consultants Georgia",
    alt: "Abroad Study Consultancy",
  },
  {
    url: "https://www.aliff.in/country-about/germany",
    country:'germany',
    title:
      "Study Abroad Consultants Germany - Study in Germany Consultants - Aliff",
    description:
      "Looking for study abroad consultants in Germany? Let our study in Germany consultants help you navigate the admission process for top universities. Enquire now!",
    metaTitle: "Study Abroad Consultants Germany",
    alt: "Study in Germany Consultants",
  },
  {
    url: "https://www.aliff.in/country-about/hungary",
    country:'hungary',
    title: "Study Abroad Consultants Hungary - Study Abroad Agency - Aliff",
    description:
      "Looking for study abroad consultants in Hungary? Our expert study abroad agency will guide you through the process to achieve your academic goals. Enquire now!",
    metaTitle: "Study Abroad Consultants Hungary",
    alt: "Study Abroad Agency",
  },
  {
    url: "https://www.aliff.in/country-about/india",
    country:'india',
    title:
      "Study Abroad Consultants India - Best Study Abroad Consultants in India - Aliff",
    description:
      "Looking for study abroad consultants in India? Get guidance from the best study abroad consultants in India for a smooth and successful experience. Enquire now!",
    metaTitle: "Study Abroad Consultants India",
    alt: "Best Study Abroad Consultants in India",
  },
  {
    url: "https://www.aliff.in/country-about/ireland",
    country:'ireland',
    title: "Study Abroad Consultants Ireland - Study Consultants - Aliff",
    description:
      "Looking for study abroad consultants in Ireland? Connect with expert study consultants to secure your spot in top universities abroad. Enquire now for more info!",
    metaTitle: "Study Abroad Consultants Ireland",
    alt: "Study Consultants",
  },
  {
    url: "https://www.aliff.in/country-about/italy",
    country:'italy',
    title: "Study Abroad Consultants Italy - Foreign Study Consultancy - Aliff",
    description:
      "Looking for study abroad consultants in Italy? Our foreign study consultancy can help you navigate the admission process with ease. Enquire now for expert support!",
    metaTitle: "Study Abroad Consultants Italy",
    alt: "Foreign Study Consultancy",
  },
  {
    url: "https://www.aliff.in/country-about/latvia",
    country:'latvia',
    title: "Study Abroad Consultants Latvia - Study Abroad Counselling - Aliff",
    description:
      "Looking for study abroad consultants in Latvia? Get professional study abroad counselling to guide your educational journey abroad. Enquire now!",
    metaTitle: "Study Abroad Consultants Latvia",
    alt: "Study Abroad Counselling",
  },
  {
    url: "https://www.aliff.in/country-about/malaysia",
    country:'malaysia',
    title: "Study Abroad Consultants Malaysia - Best Study Consultant - Aliff",
    description:
      "Looking for study abroad consultants in Malaysia? Work with the best study consultants to explore educational opportunities overseas. Enquire now for more details!",
    metaTitle: "Study Abroad Consultants Malaysia",
    alt: "Best Study Consultant",
  },
  {
    url: "https://www.aliff.in/country-about/netherlands",
    country:'netherlands',
    title:
      "Study Abroad Consultants Netherlands - Foreign Study Consultancy - Aliff",
    description:
      "Looking for study abroad consultants in the Netherlands? Our foreign study consultancy provides expert guidance for your academic success. Enquire now!",
    metaTitle: "Study Abroad Consultants Netherlands",
    alt: "Foreign Study Consultancy",
  },
  {
    url: "https://www.aliff.in/country-about/new_zealand",
    country:'new-zealand',
    title: "Study Abroad Consultants New Zealand - Study Abroad Agency - Aliff",
    description:
      "Looking for study abroad consultants in New Zealand? Connect with our experienced study abroad agency to plan your future overseas. Enquire now!",
    metaTitle: "Study Abroad Consultants New Zealand",
    alt: "Study Abroad Agency",
  },
  {
    url: "https://www.aliff.in/country-about/north_cyprus",
    country:'north-cyprus',
    title:
      "Study Abroad Consultants North Cyprus - Study Abroad Counselling - Aliff",
    description:
      "Looking for study abroad consultants in North Cyprus? Our study abroad counselling offers expert advice to guide your academic journey. Enquire now for more details!",
    metaTitle: "Study Abroad Consultants North Cyprus",
    alt: "Study Abroad Counselling",
  },
  {
    url: "https://www.aliff.in/country-about/poland",
    country:'poland',
    title: "Study Abroad Consultants Poland - Abroad Study Consultancy - Aliff",
    description:
      "Looking for study abroad consultants in Poland? Get guidance from our abroad study consultancy to help you succeed in your international education. Enquire now!",
    metaTitle: "Study Abroad Consultants Poland",
    alt: "Abroad Study Consultancy",
  },
  {
    url: "https://www.aliff.in/country-about/russia",
    country:'russia',
    title:
      "Study Abroad Consultants Russia - Foreign Study Consultancy - Aliff",
    description:
      "Looking for study abroad consultants in Russia? Get expert advice from a leading foreign study consultancy for your study abroad plans. Enquire now!",
    metaTitle: "Study Abroad Consultants Russia",
    alt: "Foreign Study Consultancy",
  },
  {
    url: "https://www.aliff.in/country-about/singapore",
    country:'singapore',
    title: "Study Abroad Consultants Singapore - Best Study Consultant - Aliff",
    description:
      "Looking for study abroad consultants in Singapore? Work with the best study consultants to explore educational opportunities overseas. Enquire now!",
    metaTitle: "Study Abroad Consultants Singapore",
    alt: "Best Study Consultant",
  },
  {
    url: "https://www.aliff.in/country-about/spain",
    country:'spain',
    title: "Study Abroad Consultants Spain - Study Consultants - Aliff",
    description:
      "Looking for study abroad consultants in Spain? Our experienced study consultants can help you secure admission in top universities abroad. Enquire now!",
    metaTitle: "Study Abroad Consultants Spain",
    alt: "Study Consultants",
  },
  {
    url: "https://www.aliff.in/country-about/switzerland",
    country:'switzerland',
    title: "Study Abroad Consultants Switzerland - Study Abroad Agency - Aliff",
    description:
      "Looking for study abroad consultants in Switzerland? Get expert advice from our study abroad agency to guide your overseas education journey. Enquire now!",
    metaTitle: "Study Abroad Consultants Switzerland",
    alt: "Study Abroad Agency",
  },
  {
    url: "https://www.aliff.in/country-about/uae",
    country:'uae',
    title: "Study Abroad Consultants UAE - Abroad Study Consultancy - Aliff",
    description:
      "Looking for study abroad consultants in UAE? Get professional help from our abroad study consultancy for your overseas education journey. Enquire now!",
    metaTitle: "Study Abroad Consultants UAE",
    alt: "Abroad Study Consultancy",
  },
  {
    url: "https://www.aliff.in/country-about/uk",
    country:'uk',
    title: "Study Abroad Consultants UK - Study Abroad Counselling - Aliff",
    description:
      "Looking for study abroad consultants in the UK? Our study abroad counselling offers tailored guidance to help you succeed in your studies abroad. Enquire now!",
    metaTitle: "Study Abroad Consultants UK",
    alt: "Study Abroad Counselling",
  },
  {
    url: "https://www.aliff.in/country-about/usa",
    country:'usa',
    title:
      "Study Abroad Consultants USA - Best Study Abroad Consultants - Aliff",
    description:
      "Looking for study abroad consultants in the USA? Get guidance from the best study abroad consultants for a successful academic future. Enquire now!",
    metaTitle: "Study Abroad Consultants USA",
    alt: "Best Study Abroad Consultants",
  },
];



// WEBPACK FOOTER //
// ./src/data/metaInfoCountry.js